export default {
  bind(el, binding) {
      el.innerText = 'ул. Студенческая, 10 ТЦ «Ланской», 2 этаж, офис В51'
  },
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/VueApplication/Directives/showroomAddressDirective.js